import dayjs from "dayjs";
import { cafeCategorias } from "../Cotacoes/Intergraos/IntergraosCafeBica";

const formatBRL = (value) =>
  value
    ? value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    : value === 0
    ? value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    : "-";

const formatUSD = (value) =>
  value
    ? value.toLocaleString("en-US", { style: "currency", currency: "USD" })
    : "-";

const formatDate = (date) =>
  date ? dayjs(date).format("DD/MM/YYYY HH:mm:ss") : "-";

const formatCafeCategories = (category) =>
  cafeCategorias.find((value) => value.value === category.toString()).label;

export const columnConfigs = {
  soja: [
    { title: "UF", dataIndex: "soj_uf", key: "soj_uf" },
    {
      title: "Data",
      dataIndex: "soj_data",
      key: "soj_data",
      render: formatDate,
    },
    {
      title: "Compra",
      dataIndex: "soj_comp",
      key: "soj_comp",
      render: formatBRL,
    },
    {
      title: "Compra (US$)",
      dataIndex: "dol_soj_comp",
      key: "dol_soj_comp",
      render: formatUSD,
    },
    {
      title: "Compra Mínima",
      dataIndex: "soj_comp_min",
      key: "soj_comp_min",
      render: formatBRL,
    },
    {
      title: "Compra Mínima (US$)",
      dataIndex: "dol_soj_comp_min",
      key: "dol_soj_comp_min",
      render: formatUSD,
    },
  ],
  cafe: [
    {
      title: "Categoria",
      dataIndex: "caf_categoria",
      key: "caf_categoria",
      render: formatCafeCategories,
    },
    {
      title: "Data",
      dataIndex: "caf_data",
      key: "caf_data",
      render: formatDate,
    },
    {
      title: "Valor Máximo",
      dataIndex: "caf_maximo",
      key: "caf_maximo",
      render: formatBRL,
    },
    {
      title: "Valor Máximo (US$)",
      dataIndex: "dol_caf_maximo",
      key: "dol_caf_maximo",
      render: formatUSD,
    },
    {
      title: "Valor Mínimo",
      dataIndex: "caf_minimo",
      key: "caf_minimo",
      render: formatBRL,
    },
    {
      title: "Valor Mínimo (US$)",
      dataIndex: "dol_caf_minimo",
      key: "dol_caf_minimo",
      render: formatUSD,
    },
  ],
  milho: [
    { title: "UF", dataIndex: "mil_uf", key: "mil_uf" },
    {
      title: "Data",
      dataIndex: "mil_data",
      key: "mil_data",
      render: formatDate,
    },
    {
      title: "Compra Mín.",
      dataIndex: "mil_compr_mn",
      key: "mil_compr_mn",
      render: formatBRL,
    },
    {
      title: "Compra Mín. (US$)",
      dataIndex: "dol_mil_compr_mn",
      key: "dol_mil_compr_mn",
      render: formatUSD,
    },
    {
      title: "Compra Máx.",
      dataIndex: "mil_compr_mx",
      key: "mil_compr_mx",
      render: formatBRL,
    },
    {
      title: "Compra Máx. (US$)",
      dataIndex: "dol_mil_compr_mx",
      key: "dol_mil_compr_mx",
      render: formatUSD,
    },
  ],
  vaca: [
    { title: "UF", dataIndex: "cot_uf", key: "cot_uf" },
    {
      title: "Data",
      dataIndex: "cot_data",
      key: "cot_data",
      render: formatDate,
    },
    {
      title: "Valor Vaca",
      dataIndex: "cot_vaca",
      key: "cot_vaca",
      render: formatBRL,
    },
    {
      title: "Valor Vaca (US$)",
      dataIndex: "dol_cot_boi",
      key: "dol_cot_boi",
      render: formatUSD,
    },
    {
      title: "Valor Vaca Mín.",
      dataIndex: "cot_boi_min",
      key: "cot_boi_min",
      render: formatBRL,
    },
    {
      title: "Valor Vaca Mín. (US$)",
      dataIndex: "dol_cot_boi_min",
      key: "dol_cot_boi_min",
      render: formatUSD,
    },
  ],
  bezerro: [
    { title: "UF", dataIndex: "cot_uf", key: "cot_uf" },
    {
      title: "Data",
      dataIndex: "cot_data",
      key: "cot_data",
      render: formatDate,
    },
    {
      title: "Valor",
      dataIndex: "cot_magro",
      key: "cot_magro",
      render: formatBRL,
    },
    {
      title: "Valor (US$)",
      dataIndex: "dol_cot_boi",
      key: "dol_cot_boi",
      render: formatUSD,
    },
    {
      title: "Valor Mín.",
      dataIndex: "cot_boi_min",
      key: "cot_boi_min",
      render: formatBRL,
    },
    {
      title: "Valor Mín. (US$)",
      dataIndex: "dol_cot_boi_min",
      key: "dol_cot_boi_min",
      render: formatUSD,
    },
  ],
  bezerra: [
    { title: "UF", dataIndex: "boi_uf", key: "boi_uf" },
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Valor",
      dataIndex: "boi_valor",
      key: "boi_valor",
      render: formatBRL,
    },
    {
      title: "Valor (US$)",
      dataIndex: "dol_boi_valor",
      key: "dol_boi_valor",
      render: formatUSD,
    },
  ],
  boigordo: [
    { title: "UF", dataIndex: "cot_uf", key: "cot_uf" },
    {
      title: "Data",
      dataIndex: "cot_data",
      key: "cot_data",
      render: formatDate,
    },
    {
      title: "Valor",
      dataIndex: "cot_boi",
      key: "cot_boi",
      render: formatBRL,
    },
    {
      title: "Valor (US$)",
      dataIndex: "dol_cot_boi",
      key: "dol_cot_boi",
      render: formatUSD,
    },
    {
      title: "Valor Mín.",
      dataIndex: "cot_boi_min",
      key: "cot_boi_min",
      render: formatBRL,
    },
    {
      title: "Valor Mín. (US$)",
      dataIndex: "dol_cot_boi_min",
      key: "dol_cot_boi_min",
      render: formatUSD,
    },
  ],
  boiatacado: [
    { title: "UF", dataIndex: "ata_uf", key: "ata_uf" },
    {
      title: "Data",
      dataIndex: "ata_data",
      key: "ata_data",
      render: formatDate,
    },
    {
      title: "Agulha",
      dataIndex: "ata_agulha",
      key: "ata_agulha",
      render: formatBRL,
    },
    {
      title: "Agulha (US$)",
      dataIndex: "dol_agulha",
      key: "dol_agulha",
      render: formatUSD,
    },
    {
      title: "Casado",
      dataIndex: "ata_casado",
      key: "ata_casado",
      render: formatBRL,
    },
    {
      title: "Casado (US$)",
      dataIndex: "dol_casado",
      key: "dol_casado",
      render: formatUSD,
    },
    {
      title: "Dia Boi",
      dataIndex: "ata_diaboi",
      key: "ata_diaboi",
      render: formatBRL,
    },
    {
      title: "Dia Boi (US$)",
      dataIndex: "dol_diaboi",
      key: "dol_diaboi",
      render: formatUSD,
    },
    {
      title: "Dia Osso Boi",
      dataIndex: "ata_diaossoboi",
      key: "ata_diaossoboi",
      render: formatBRL,
    },
    {
      title: "Dia Osso Boi (US$)",
      dataIndex: "dol_diaossoboi",
      key: "dol_diaossoboi",
      render: formatUSD,
    },
    {
      title: "Dia Vaca",
      dataIndex: "ata_diavac",
      key: "ata_diavac",
      render: formatBRL,
    },
    {
      title: "Dia Vaca (US$)",
      dataIndex: "dol_diavac",
      key: "dol_diavac",
      render: formatUSD,
    },
    {
      title: "Dia Osso Vaca",
      dataIndex: "ata_diaossovac",
      key: "ata_diaossovac",
      render: formatBRL,
    },
    {
      title: "Dia Osso Vaca (US$)",
      dataIndex: "dol_diaossovac",
      key: "dol_diaossovac",
      render: formatUSD,
    },
    {
      title: "Equifis",
      dataIndex: "ata_equifis",
      key: "ata_equifis",
      render: formatBRL,
    },
    {
      title: "Equifis (US$)",
      dataIndex: "dol_equifis",
      key: "dol_equifis",
      render: formatUSD,
    },
    {
      title: "Tra Boi",
      dataIndex: "ata_traboi",
      key: "ata_traboi",
      render: formatBRL,
    },
    {
      title: "Tra Boi (US$)",
      dataIndex: "dol_traboi",
      key: "dol_traboi",
      render: formatUSD,
    },
    {
      title: "Tra Vaca",
      dataIndex: "ata_travac",
      key: "ata_travac",
      render: formatBRL,
    },
    {
      title: "Tra Vaca (US$)",
      dataIndex: "dol_travac",
      key: "dol_travac",
      render: formatUSD,
    },
  ],
  boiinnatura: [
    { title: "UF", dataIndex: "boi_uf", key: "boi_uf" },
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Boi Casado",
      dataIndex: "boi_casado",
      key: "boi_casado",
      render: formatBRL,
    },
    {
      title: "Vaca Casado",
      dataIndex: "vaca_casado",
      key: "vaca_casado",
      render: formatBRL,
    },
    {
      title: "Diant Boi",
      dataIndex: "diant_boi",
      key: "diant_boi",
      render: formatBRL,
    },
    {
      title: "Diant Vaca",
      dataIndex: "diant_vaca",
      key: "diant_vaca",
      render: formatBRL,
    },
    {
      title: "Pt Agu Boi",
      dataIndex: "pt_agu_boi",
      key: "pt_agu_boi",
      render: formatBRL,
    },
    {
      title: "Pt Agu Vaca",
      dataIndex: "pt_agu_vaca",
      key: "pt_agu_vaca",
      render: formatBRL,
    },
    {
      title: "Pt Agu Boi Esp",
      dataIndex: "pt_agu_boi_esp",
      key: "pt_agu_boi_esp",
      render: formatBRL,
    },
    {
      title: "Tras Boi",
      dataIndex: "tras_boi",
      key: "tras_boi",
      render: formatBRL,
    },
    {
      title: "Tras Vaca",
      dataIndex: "tras_vaca",
      key: "tras_vaca",
      render: formatBRL,
    },
    {
      title: "Tras Boi Av",
      dataIndex: "tras_boi_av",
      key: "tras_boi_av",
      render: formatBRL,
    },
    {
      title: "Tras Vaca Av",
      dataIndex: "tras_vaca_av",
      key: "tras_vaca_av",
      render: formatBRL,
    },
  ],
  charque: [
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Injetado Diant",
      dataIndex: "injetado_diant",
      key: "injetado_diant",
      render: formatBRL,
    },
    {
      title: "Injetado Pa",
      dataIndex: "injetado_pa",
      key: "injetado_pa",
      render: formatBRL,
    },
    {
      title: "Manteado Diant",
      dataIndex: "manteado_diant",
      key: "manteado_diant",
      render: formatBRL,
    },
    {
      title: "Manteado Pa",
      dataIndex: "manteado_pa",
      key: "manteado_pa",
      render: formatBRL,
    },
  ],
  cortes: [
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Acem",
      dataIndex: "acem",
      key: "acem",
      render: formatBRL,
    },
    {
      title: "Beiço",
      dataIndex: "beico",
      key: "beico",
      render: formatBRL,
    },
    {
      title: "Cupim",
      dataIndex: "cupim",
      key: "cupim",
      render: formatBRL,
    },
    {
      title: "Fraldão",
      dataIndex: "fraldao",
      key: "fraldao",
      render: formatBRL,
    },
    {
      title: "Fraldinha",
      dataIndex: "fraldinha",
      key: "fraldinha",
      render: formatBRL,
    },
    {
      title: "Lombinho",
      dataIndex: "lombinho",
      key: "lombinho",
      render: formatBRL,
    },
    {
      title: "Medula",
      dataIndex: "medula",
      key: "medula",
      render: formatBRL,
    },
    {
      title: "Nervo",
      dataIndex: "nervo",
      key: "nervo",
      render: formatBRL,
    },
    {
      title: "Pacu",
      dataIndex: "pacu",
      key: "pacu",
      render: formatBRL,
    },
    {
      title: "Paleta c/ Músculo",
      dataIndex: "paleta_cmusculo",
      key: "paleta_cmusculo",
      render: formatBRL,
    },
    {
      title: "Paleta s/ Músculo",
      dataIndex: "paleta_smusculo",
      key: "paleta_smusculo",
      render: formatBRL,
    },
    {
      title: "Peito",
      dataIndex: "peito",
      key: "peito",
      render: formatBRL,
    },
    {
      title: "Recorte",
      dataIndex: "recorte",
      key: "recorte",
      render: formatBRL,
    },
    {
      title: "Tripa",
      dataIndex: "tripa",
      key: "tripa",
      render: formatBRL,
    },
    {
      title: "Veia",
      dataIndex: "veia",
      key: "veia",
      render: formatBRL,
    },
    {
      title: "Vergalho",
      dataIndex: "vergalho",
      key: "vergalho",
      render: formatBRL,
    },
  ],
  frango: [
    { title: "UF", dataIndex: "cot_uf", key: "cot_uf" },
    {
      title: "Data",
      dataIndex: "cot_data",
      key: "cot_data",
      render: formatDate,
    },
    {
      title: "Valor",
      dataIndex: "cot_kg",
      key: "cot_kg",
      render: formatBRL,
    },
    {
      title: "Valor (US$)",
      dataIndex: "dol_soj_comp",
      key: "dol_soj_comp",
      render: formatUSD,
    },
  ],
  cortestrad: [
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Alcatra Comp",
      dataIndex: "alcatra_comp",
      key: "alcatra_comp",
      render: formatBRL,
    },
    {
      title: "Alcatra Maminha",
      dataIndex: "alcatra_maminha",
      key: "alcatra_maminha",
      render: formatBRL,
    },
    {
      title: "Alcatra Miolo",
      dataIndex: "alcatra_miolo",
      key: "alcatra_miolo",
      render: formatBRL,
    },
    {
      title: "Capa File",
      dataIndex: "capa_file",
      key: "capa_file",
      render: formatBRL,
    },
    {
      title: "Contra File",
      dataIndex: "contra_file",
      key: "contra_file",
      render: formatBRL,
    },
    {
      title: "Coxão Duro",
      dataIndex: "coxao_duro",
      key: "coxao_duro",
      render: formatBRL,
    },
    {
      title: "Coxão Mole",
      dataIndex: "coxao_mole",
      key: "coxao_mole",
      render: formatBRL,
    },
    {
      title: "Cupim A",
      dataIndex: "cupim_a",
      key: "cupim_a",
      render: formatBRL,
    },
    {
      title: "Cupim B",
      dataIndex: "cupim_b",
      key: "cupim_b",
      render: formatBRL,
    },
    {
      title: "File c/ Cordão",
      dataIndex: "file_ccordao",
      key: "file_ccordao",
      render: formatBRL,
    },
    {
      title: "File s/ Cordão",
      dataIndex: "file_scordao",
      key: "file_scordao",
      render: formatBRL,
    },
    {
      title: "Lagarto",
      dataIndex: "lagarto",
      key: "lagarto",
      render: formatBRL,
    },
    {
      title: "Maminha",
      dataIndex: "maminha",
      key: "maminha",
      render: formatBRL,
    },
    {
      title: "Musculo",
      dataIndex: "musculo",
      key: "musculo",
      render: formatBRL,
    },
    {
      title: "Patinho",
      dataIndex: "patinho",
      key: "patinho",
      render: formatBRL,
    },
    {
      title: "Picanha A",
      dataIndex: "picanha_a",
      key: "picanha_a",
      render: formatBRL,
    },
    {
      title: "Picanha B",
      dataIndex: "picanha_b",
      key: "picanha_b",
      render: formatBRL,
    },
  ],
  couro: [
    { title: "UF", dataIndex: "boi_uf", key: "boi_uf" },
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Verde 30d",
      dataIndex: "verde_30",
      key: "verde_30",
      render: formatBRL,
    },
    {
      title: "Verde A/V",
      dataIndex: "verde_av",
      key: "verde_av",
      render: formatBRL,
    },
    {
      title: "Salgado",
      dataIndex: "salg",
      key: "salg",
      render: formatBRL,
    },
    {
      title: "Prazo Salgado",
      dataIndex: "salg_prazo",
      key: "salg_prazo",
    },
  ],
  diversos: [
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Bilis Conc",
      dataIndex: "bilis_conc",
      key: "bilis_conc",
      render: formatBRL,
    },
    {
      title: "Prazo",
      dataIndex: "p_bilis_conc",
      key: "p_bilis_conc",
    },
    {
      title: "Bilis Liq",
      dataIndex: "bilis_liq",
      key: "bilis_liq",
      render: formatBRL,
    },
    {
      title: "Prazo",
      dataIndex: "p_bilis_liq",
      key: "p_bilis_liq",
    },
    {
      title: "Calc Biliar",
      dataIndex: "calc_biliar",
      key: "calc_biliar",
      render: formatBRL,
    },
    {
      title: "Prazo",
      dataIndex: "p_calc_biliar",
      key: "p_calc_biliar",
    },
    {
      title: "Casco Chifre",
      dataIndex: "casco_chifre",
      key: "casco_chifre",
      render: formatBRL,
    },
    {
      title: "Prazo",
      dataIndex: "p_casco_chifre",
      key: "p_casco_chifre",
    },
    {
      title: "Crina",
      dataIndex: "crina",
      key: "crina",
      render: formatBRL,
    },
    {
      title: "Prazo",
      dataIndex: "p_crina",
      key: "p_crina",
    },
    {
      title: "Pelo Orelha",
      dataIndex: "pelo_orelha",
      key: "pelo_orelha",
      render: formatBRL,
    },
    {
      title: "Prazo",
      dataIndex: "p_pelo_orelha",
      key: "p_pelo_orelha",
    },
  ],
  miudos: [
    { title: "UF", dataIndex: "boi_uf", key: "boi_uf" },
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "Baço",
      dataIndex: "baco",
      key: "baco",
      render: formatBRL,
    },
    {
      title: "Bucho",
      dataIndex: "bucho",
      key: "bucho",
      render: formatBRL,
    },
    {
      title: "Coração",
      dataIndex: "coracao",
      key: "coracao",
      render: formatBRL,
    },
    {
      title: "Fígado",
      dataIndex: "figado",
      key: "figado",
      render: formatBRL,
    },
    {
      title: "Língua",
      dataIndex: "lingua",
      key: "lingua",
      render: formatBRL,
    },
    {
      title: "Miolo",
      dataIndex: "miolo",
      key: "miolo",
      render: formatBRL,
    },
    {
      title: "Mocotó",
      dataIndex: "mocoto",
      key: "mocoto",
      render: formatBRL,
    },
    {
      title: "Pulmão",
      dataIndex: "pulmao",
      key: "pulmao",
      render: formatBRL,
    },
    {
      title: "Rabo",
      dataIndex: "rabo",
      key: "rabo",
      render: formatBRL,
    },
    {
      title: "Rins",
      dataIndex: "rins",
      key: "rins",
      render: formatBRL,
    },
    {
      title: "Testículos",
      dataIndex: "testiculos",
      key: "testiculos",
      render: formatBRL,
    },
  ],
  industrializada: [
    { title: "UF", dataIndex: "boi_uf", key: "boi_uf" },
    {
      title: "Data",
      dataIndex: "boi_data",
      key: "boi_data",
      render: formatDate,
    },
    {
      title: "PA Boi c/ Osso Resfriado",
      dataIndex: "pa_boi_cosso",
      key: "pa_boi_cosso",
      render: formatBRL,
    },
    {
      title: "PA Vaca c/ Osso Resfriado",
      dataIndex: "pa_vaca_cosso",
      key: "pa_vaca_cosso",
      render: formatBRL,
    },
    {
      title: "PA s/ Osso",
      dataIndex: "pa_sosso",
      key: "pa_sosso",
      render: formatBRL,
    },
    {
      title: "Dianteiro s/ Osso",
      dataIndex: "diant_sosso",
      key: "diant_sosso",
      render: formatBRL,
    },
    {
      title: "Diant. Boi c/ Osso Resf.",
      dataIndex: "diant_boi_cosso",
      key: "diant_boi_cosso",
      render: formatBRL,
    },
    {
      title: "Diant. Vaca c/ Osso Resf.",
      dataIndex: "diant_vaca_cosso",
      key: "diant_vaca_cosso",
      render: formatBRL,
    },
    {
      title: "Industrial",
      dataIndex: "carne_ind",
      key: "carne_ind",
      render: formatBRL,
    },
    {
      title: "Industrial Esp.",
      dataIndex: "carne_ind_esp",
      key: "carne_ind_esp",
      render: formatBRL,
    },
    {
      title: "Conserva",
      dataIndex: "carne_cons",
      key: "carne_cons",
      render: formatBRL,
    },
    {
      title: "Carne Sangria",
      dataIndex: "carne_sang",
      key: "carne_sang",
      render: formatBRL,
    },
    {
      title: "Músculo Dianteiro",
      dataIndex: "musc_diant",
      key: "musc_diant",
      render: formatBRL,
    },
    {
      title: "Osso do Patinho",
      dataIndex: "osso_pat",
      key: "osso_pat",
      render: formatBRL,
    },
  ],
  frangocortes: [
    {
      title: "Data",
      dataIndex: "ave_data",
      key: "ave_data",
      render: formatDate,
    },
    {
      title: "Frango Resfriado",
      dataIndex: "fran_resf",
      key: "fran_resf",
      render: formatBRL,
    },
    {
      title: "Frango Congelado",
      dataIndex: "fran_cong",
      key: "fran_cong",
      render: formatBRL,
    },
    {
      title: "Carcaça Cong.",
      dataIndex: "carc_cong",
      key: "carc_cong",
      render: formatBRL,
    },
    {
      title: "Asa",
      dataIndex: "asa",
      key: "asa",
      render: formatBRL,
    },
    {
      title: "Coração",
      dataIndex: "coracao",
      key: "coracao",
      render: formatBRL,
    },
    {
      title: "Coxa",
      dataIndex: "coxa",
      key: "coxa",
      render: formatBRL,
    },
    {
      title: "Coxa c/ Sobrecoxa",
      dataIndex: "coxa_sobcoxa",
      key: "coxa_sobcoxa",
      render: formatBRL,
    },
    {
      title: "Dorso",
      dataIndex: "dorso",
      key: "dorso",
      render: formatBRL,
    },
    {
      title: "Fígado",
      dataIndex: "figado",
      key: "figado",
      render: formatBRL,
    },
    {
      title: "Filé de Peito",
      dataIndex: "file_peito",
      key: "file_peito",
      render: formatBRL,
    },
    {
      title: "Moela",
      dataIndex: "moela",
      key: "moela",
      render: formatBRL,
    },
    {
      title: "Peito",
      dataIndex: "peito",
      key: "peito",
      render: formatBRL,
    },
    {
      title: "CMS - 25%",
      dataIndex: "cms",
      key: "cms",
      render: formatBRL,
    },
  ],
  suinocortes: [
    { title: "Data", dataIndex: "sui_data", key: "sui_data", render: formatDate },
    { title: "Barriga Costela Cong.", dataIndex: "bar_ccostela_cong", key: "bar_ccostela_cong", render: formatBRL },
    { title: "Barriga Costela Sal.", dataIndex: "bar_ccostela_sal", key: "bar_ccostela_sal", render: formatBRL },
    { title: "Suíno Costela Cong.", dataIndex: "bar_scostela_cong", key: "bar_scostela_cong", render: formatBRL },
    { title: "Suíno Costela Sal.", dataIndex: "bar_scostela_sal", key: "bar_scostela_sal", render: formatBRL },
    { title: "Copa Cong.", dataIndex: "copa_cong", key: "copa_cong", render: formatBRL },
    { title: "Copa Sal.", dataIndex: "copa_sal", key: "copa_sal", render: formatBRL },
    { title: "Couro Cong.", dataIndex: "couro_cong", key: "couro_cong", render: formatBRL },
    { title: "Couro Sal.", dataIndex: "couro_sal", key: "couro_sal", render: formatBRL },
    { title: "Costela Cong.", dataIndex: "cost_cong", key: "cost_cong", render: formatBRL },
    { title: "Costela Sal.", dataIndex: "cost_sal", key: "cost_sal", render: formatBRL },
    { title: "Filé Cong.", dataIndex: "filet_cong", key: "filet_cong", render: formatBRL },
    { title: "Filé Sal.", dataIndex: "filet_sal", key: "filet_sal", render: formatBRL },
    { title: "Língua Cong.", dataIndex: "lingua_cong", key: "lingua_cong", render: formatBRL },
    { title: "Língua Sal.", dataIndex: "lingua_sal", key: "lingua_sal", render: formatBRL },
    { title: "Orelha Cong.", dataIndex: "orelha_cong", key: "orelha_cong", render: formatBRL },
    { title: "Orelha Sal.", dataIndex: "orelha_sal", key: "orelha_sal", render: formatBRL },
    { title: "Pé Cong.", dataIndex: "pe_cong", key: "pe_cong", render: formatBRL },
    { title: "Pé Sal.", dataIndex: "pe_sal", key: "pe_sal", render: formatBRL },
    { title: "Rabo Cong.", dataIndex: "rabo_cong", key: "rabo_cong", render: formatBRL },
    { title: "Rabo Sal.", dataIndex: "rabo_sal", key: "rabo_sal", render: formatBRL },
    { title: "Retalho Gordo Cong.", dataIndex: "ret_gordo_cong", key: "ret_gordo_cong", render: formatBRL },
    { title: "Retalho Gordo Sal.", dataIndex: "ret_gordo_sal", key: "ret_gordo_sal", render: formatBRL },
    { title: "Retalho Magro Cong.", dataIndex: "ret_magro_cong", key: "ret_magro_cong", render: formatBRL },
    { title: "Retalho Magro Sal.", dataIndex: "ret_magro_sal", key: "ret_magro_sal", render: formatBRL },
    { title: "Toucinho Lombo Cong.", dataIndex: "touc_lombo_cong", key: "touc_lombo_cong", render: formatBRL },
    { title: "Toucinho Lombo Sal.", dataIndex: "touc_lombo_sal", key: "touc_lombo_sal", render: formatBRL },
    { title: "Toucinho Sem Couro Cong.", dataIndex: "touc_scouro_cong", key: "touc_scouro_cong", render: formatBRL },
    { title: "Toucinho Sem Couro Sal.", dataIndex: "touc_scouro_sal", key: "touc_scouro_sal", render: formatBRL },
  ],
  suinocorstesesp: [
    { title: "Data", dataIndex: "sui_data", key: "sui_data", render: formatDate },
    { title: "Carcaça Especial Atacado", dataIndex: "carc_esp_ata", key: "carc_esp_ata", render: formatBRL },
    { title: "Carcaça Especial Distribuição", dataIndex: "carc_esp_dist", key: "carc_esp_dist", render: formatBRL },
    { title: "Carretinha Congelada", dataIndex: "carret_cong", key: "carret_cong", render: formatBRL },
    { title: "Lombo Congelado", dataIndex: "lombo_cong", key: "lombo_cong", render: formatBRL },
    { title: "Paleta Sem Osso", dataIndex: "paleta_sosso", key: "paleta_sosso", render: formatBRL },
    { title: "Paleta Com Osso", dataIndex: "paleta_cosso", key: "paleta_cosso", render: formatBRL },
    { title: "Pernil Especial", dataIndex: "pernil_esp", key: "pernil_esp", render: formatBRL },
    { title: "Pernil Industrial Com Osso", dataIndex: "pernil_ind_cosso", key: "pernil_ind_cosso", render: formatBRL },
  ]
};
